export const IconBackgroundTestIdFactory = {
    // bases
    getIconBackgroundBase: () => 'icon-background',
    // for test id generation
    getIconBackgroundTestId: (testId) => [IconBackgroundTestIdFactory.getIconBackgroundBase(), testId].join('-'),
};
